import { useState } from 'react'
import { PageHeader, TabsComponent, CardComponent } from '@/components/molecules'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { ROUTES } from '@/utils/constants/routesConstants'
import { SalesTargetList, SalesTargetsActivitiesList } from '@/containers'
import { HeaderTitle, Icon } from '@/components/atoms'
import { Header } from '@/utils/constants/header'
import { useSalesTargets } from '@/hooks/useSalesTargets'

export const SalesTargetHome = () => {
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const tab = params.get('tab') ? parseInt(params.get('tab')) : 0
  const { salesTargetsData } = useSalesTargets()
  const isLoading = !salesTargetsData?.data || salesTargetsData?.length === 0

  const cardList = [
    // {
    //   centralIcon: 'local_police',
    //   ctaPrimary: {
    //     text: 'Add Activity',
    //     onClick: () => navigate(ROUTES.ADD_ACTIVITY),
    //   },
    //   title: '27 Activities are active',
    // },
    {
      centralIcon: 'location_searching',
      ctaPrimary: {
        text: 'Add Sales Target',
        onClick: () => navigate(ROUTES.ADD_SALES_TARGET),
      },
      title: `${salesTargetsData?.activeCount} Sales Targets are active`,
    },
    // {
    //   centralIcon: 'list_alt',
    //   ctaPrimary: {
    //     text: 'Add NBA',
    //     onClick: () => alert('NBA is part of other module.'),
    //   },
    //   title: '12 NBA Items',
    // },
  ]

  const tabList = [
    {
      id: 'activities',
      tabLabel: 'Activities',
      title: 'Activity List',
      tabComponent: <SalesTargetsActivitiesList />,
    },
    {
      id: 'sales-target',
      tabLabel: 'Sales Target',
      title: 'Sales Target Table',
      tabComponent: <SalesTargetList />,
    },
    // {
    //   id: 'nba',
    //   tabLabel: 'NBA',
    //   title: 'NBA List',
    //   tabComponent: <div>NBA Data</div>,
    // },
  ]

  const defaultTitle = tabList[tab]?.title || ''
  const [title, setTitle] = useState(defaultTitle)

  const getSelectedTabIndex = i => {
    const tabObj = tabList[i]
    setTitle(tabObj?.title)
  }

  return (
    <div className="salesTargetsContainer flex flex-col">
      <PageHeader title="Loyalty - Earn Points" />
      <div className="targetCardComponent mb-5">
        <CardComponent cardList={cardList} isLoading={isLoading} />
      </div>
      <div className="salesTargetsTitleSection relative">
        <HeaderTitle headingLevel={Header.SectionTitle} title={title} className="salesTargetsDataTableHeading" />
        <span className="salesTargetsSettingsIcon absolute h-8 w-8 rounded p-2">
          <Icon icon="settings" isDark={true} size="small" className="h-4 w-4" />
        </span>
      </div>
      <TabsComponent tabList={tabList} defaultTabIndex={tab} onTabChange={getSelectedTabIndex} />
    </div>
  )
}
